import { createAction, props } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { ActiveCallsFilterOptions } from '../../models/active-calls-filter-option';
import { ActiveCallsRegisterListItem } from '../../models/active-calls-register-results.model';

const area = 'System Active Calls Register';
export const systemActiveCallsRegisterAdapterActions = createRegisterActions<ActiveCallsRegisterListItem>(area);

export const createActiveCalls = createAction(`[${area}] Create ActiveCalls`);

export const openDialog = createAction(`[${area}] Open Dialog`, props<{ callLogs: any }>());

export const hangupActiveCall = createAction(
   `[${area}] Hangup Active Call`,
   props<{ activeCall: ActiveCallsRegisterListItem }>()
);

export const hangupActiveCallSuccess = createAction(`[${area}] Hangup Active Call Success`);

export const systemActiveCallsRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: ActiveCallsFilterOptions[] }>()
);

export const setOrderingOptionsFromSessionStorage = createAction(
   `[${area}] Set Ordering Options From Session Storage`,
   props<{ orderingOptions: OrderingOption[] | null }>()
);

export const toggleAutoRefresh = createAction(`[${area}] Toggle Auto Refresh`, props<{ isAutoRefresh: boolean }>());
